import Login from "@/views/Login";
import Library from "@/views/Library";
import Cards from "@/views/Cards";
import Card from "@/views/Card";
import Report from "@/views/Report";
import MassActions from "@/views/MassActions";
import Groups from "@/views/Groups";
import Matrix from "@/views/Matrix";
import Home from "@/componentsCompany/cherkizovo/views/Home.vue";
import DynamicSettings from "@/views/settings/DynamicSettings.vue";
import Chiefs from "@/views/settings/Chiefs.vue";
import Rbac from "@/views/settings/Rbac.vue";
import Scales from "@/views/settings/Scales.vue";
import Imports from "@/componentsCompany/cherkizovo/pages/Imports.vue";
import Integration from "@/componentsCompany/cherkizovo/views/Integration.vue";
import HomeDashboard from "@/views/HomeDashboard.vue";
import AutoCreateCard from "@/componentsCompany/cherkizovo/views/AutoCreateCard.vue";

export default [
    {
        path: '/dashboards',
        name: 'Dashboards',
        component: HomeDashboard,
        meta: {title: 'Дашборды'}
    },
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {title: 'Домашняя страница'}
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {title: 'Логин', layout: 'empty-layout'}
    },
    {
        path: '/library/:type([\\w]+)',
        name: 'Library',
        component: Library,
        meta: {title: 'Библиотека'}
    },
    {
        path: '/cards',
        name: 'Cards',
        component: Cards,
        meta: {title: 'Карты'}
    },
    {
        path: '/card/:id(\\d+)',
        name: 'Card',
        component: Card,
        meta: {title: 'Карта'}
    },
    {
        path: '/report',
        name: 'Report',
        component: Report,
        meta: {title: 'Конструктор отчетов'}
    },
    {
        path: '/matrix',
        name: 'Matrix',
        component: Matrix,
        meta: {title: 'Навигатор по целям подчинённых'}
    },



    {
        path: '/settings/dynamic',
        name: 'DynamicSettings',
        component: DynamicSettings,
        meta: {title: 'Настройки'}
    },
    {
        path: '/settings/imports',
        name: 'Imports',
        component: Imports,
        meta: {title: 'Импорт'}
    },
    {
        path: '/settings/chiefs',
        name: 'Chiefs',
        component: Chiefs,
        meta: {title: 'Настройка орг. структуры'}
    },
    {
        path: '/settings/rbac',
        name: 'Rbac',
        component: Rbac,
        meta: {title: 'Настройка ролей'}
    },
    {
        path: '/settings/scales',
        name: 'Scales',
        component: Scales,
        meta: {title: 'Настройка шкал'}
    },
    {
        path: '/settings/groups',
        name: 'Groups',
        component: Groups,
        meta: {title: 'Настройка групп'}
    },
    {
        path: '/settings/mass-actions',
        name: 'MassActions',
        component: MassActions,
        meta: {title: 'Массовые действия'}
    },
    {
        path: '/settings/integration',
        name: 'Integration',
        component: Integration,
        meta: {title: 'Интеграция'}
    },
    {
        path: '/auto-create-card/:id(\\d+)',
        name: 'AutoCreateCard',
        component: AutoCreateCard,
        meta: {title: 'Автоматическое создание карты'}
    },
]
